<div class="price-on-request-container">
  <div class="content">
    <div class="form">
      <kion-headline-tag [title]="'dialog.priceOnRequest.headline' | translate"></kion-headline-tag>
      <div class="form">
        <kion-shop-contact-form
          (changed)="formChanged($event)"
          (valid)="checkFormValidation($event)"
          [msg]="'dialog.priceOnRequest.message' | translate: {message: productTitle + ' - ' + productCode}"
          [subject]="'Price enquiry'"
          [userEmail]="(user$ | async)?.uid"
          [userName]="(user$ | async) ? (user$ | async)?.firstName + ' ' + (user$ | async)?.lastName : ''">
        </kion-shop-contact-form>
        <kion-checkbox
          (requiredSelected)="checkboxSelected($event)"
          [boxes]="[checkbox]">
        </kion-checkbox>
      </div>
    </div>
    <div class="footer">
      <div class="actions">
        <kion-button (clicked)="closeDialog()"
                     [disabled]="sending" [title]="'dialog.priceOnRequest.buttons.cancel' | translate"
                     class="cancelBtn"
                     mode="discreet">
        </kion-button>
        <kion-button (clicked)="sendMessage()"
                     [disabled]="!(canProcess$ | async) || sending"
                     [title]="'dialog.priceOnRequest.buttons.submit' | translate" mode="primary">
        </kion-button>
      </div>
    </div>
  </div>
</div>
